/**
 * Controls whether a client can be assigned to night-time delivery
 * routes vs. day-time routes. Used by the distribution engine when
 * resolving which clients can show up on a given trip.
 *
 * - DAY_ONLY: client may only be on day-time routes (default).
 * - EITHER: client may appear on day or night routes.
 * - NIGHT_ONLY: client must NOT appear on a day route — only night.
 *
 * Modeled as a single tri-state enum rather than two booleans
 * (`isNightAllowed` + `isNightOnly`) so contradictory combinations
 * (e.g. night-only AND day-only) are unrepresentable.
 */
export enum ClientNightTimeEligibilityEnum {
	DAY_ONLY = 'DAY_ONLY',
	EITHER = 'EITHER',
	NIGHT_ONLY = 'NIGHT_ONLY',
}
